<template>
  <div class="container">
    <div class="mb-4 mt-4">
      <img style="width: 100%;" src="/themes/storefront/public/images/100T-Sell-To-Us-001.jpg" alt="Sell-To-Us-Images">
    </div>

    <div class="table-section">
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :line-numbers="false"
        styleClass="vgt-table bordered"
        :sort-options="{enabled: false,}"
        @on-cell-click="onCellClick"
      >
        <template slot="table-row" slot-scope="props">
            <div v-if="props.column.field === 'description'" class="description-cell">
            <div class="d-flex">
              <div v-if="rows[props.row.originalIndex].selected == true">
                <img height="100" :src="selectedProducts[props.row.originalIndex].base_image"/>
              </div>
              <div v-else>
                <drop-zone
                  :filesThumbnail="rows[props.row.originalIndex].media"
                  :filesIDs="rows[props.row.originalIndex].mediaIds"
                  :max-files="1"
                  :placeholder-img-style="'width:30px'"
                  :custom-style="'width:70px;height:80px'"
                  @dataChanged="setMedia($event, props.row.originalIndex)"
                  :query-param="'collection_name=banner_image'"
                  :endpoint="'/upload-stu-media'"
                />
              </div>
              <span class="text-danger mr-2">*</span>
              <input
                type="text"
                :id="'product-name-'+props.row.originalIndex"
                v-model="rows[props.row.originalIndex].description"
                placeholder="Find banknotes, coins and more..."
                class="table-input ml-2 h-38"
                @input="updateRow(props.row.originalIndex, 'description', $event.target.value)"
              />
            </div>

          </div>

          <div v-else-if="props.column.field === 'country_id'" class="select-cell">
            <div v-if="rows[props.row.originalIndex].selected == true">
              <span>{{ selectedProducts[props.row.originalIndex].country }}</span>
            </div>
            <div class="d-flex align-items-center" v-else>
              <span class="text-danger mr-2">*</span>
              <select
                v-model="rows[props.row.originalIndex].country_id"
                class="table-select"
                @change="updateRow(props.row.originalIndex, 'country_id', $event.target.value)"
              >
                <option value="">Select Country</option>
                <option v-for="country in countries" :key="country.id" :value="country.id">
                  {{ country.name }}
                </option>
              </select>
            </div>
          </div>

          <div v-else-if="props.column.field === 'type'" class="select-cell">
            <div v-if="rows[props.row.originalIndex].selected == true">
              <span>{{ rows[props.row.originalIndex].type }}</span>
            </div>
            <div class="d-flex align-items-center" v-else>
              <span class="text-danger mr-2">*</span>
              <select
                v-model="rows[props.row.originalIndex].type"
                class="table-select"
                @change="updateRow(props.row.originalIndex, 'type', $event.target.value)"
              >
                <option value="">Select Type</option>
                <option v-for="type in types" :key="type" :value="type">
                  {{ type }}
                </option>
              </select>
            </div>
          </div>

          <div v-else-if="props.column.field === 'condition_id'" class="select-cell">
            <div class="d-flex align-items-center">
              <span class="text-danger mr-2">*</span>
              <select
                v-model="rows[props.row.originalIndex].condition_id"
                class="table-select"
                @change="updateRow(props.row.originalIndex, 'condition_id', $event.target.value)"
              >
                <option value="">Select Condition</option>
                <option v-for="condition in conditions" :key="condition.id" :value="condition.id">
                  {{ condition.name }}
                </option>
              </select>
            </div>
          </div>

          <div v-else-if="props.column.field === 'pick'" class="input-cell">
            <div v-if="rows[props.row.originalIndex].selected == true">
              <span>{{ rows[props.row.originalIndex].pick }}</span>
            </div>
            <div v-else>
              <input
                type="text"
                v-model="rows[props.row.originalIndex].pick"
                class="table-input"
                @input="updateRow(props.row.originalIndex, 'pick', $event.target.value)"
              />
            </div>
          </div>

          <div v-else-if="props.column.field === 'denomination'" class="input-cell">
            <div v-if="rows[props.row.originalIndex].selected == true">
              <span>{{ selectedProducts[props.row.originalIndex].denomination }}</span>
            </div>
            <div v-else>
              <input
                type="text"
                v-model="rows[props.row.originalIndex].denomination"
                class="table-input"
                @input="updateRow(props.row.originalIndex, 'denomination', $event.target.value)"
              />
            </div>
          </div>

          <div v-else-if="props.column.field === 'year'" class="input-cell">
            <div v-if="rows[props.row.originalIndex].selected == true">
              <span>{{ rows[props.row.originalIndex].year }}</span>
            </div>
            <div v-else>
              <input
                type="number"
                v-model="rows[props.row.originalIndex].year"
                class="table-input"
                @input="updateRow(props.row.originalIndex, 'year', $event.target.value)"
              />
            </div>
          </div>

          <div v-else-if="props.column.field === 'customer_price'" class="d-flex align-items-center">
            <span class="text-danger mr-2">*</span>
            <div class="price-cell">
              <span class="currency">$</span>
              <input
                type="number"
                v-model="rows[props.row.originalIndex].customer_price"
                class="table-input price-input"
                @input="updateRow(props.row.originalIndex, 'customer_price', $event.target.value)"
              />
            </div>
          </div>

          <div v-else-if="props.column.field === 'customer_quantity'" class="d-flex align-items-center">
            <span class="text-danger mr-2">*</span>
            <div class="input-cell">
              <input
                type="number"
                v-model="rows[props.row.originalIndex].customer_quantity"
                class="table-input"
                @input="updateRow(props.row.originalIndex, 'customer_quantity', $event.target.value)"
              />
            </div>
          </div>

          <div v-else-if="props.column.field === 'customer_total_offer'" class="total-cell">
            ${{ calculateTotal(rows[props.row.originalIndex]) }}
          </div>

          <div v-else-if="props.column.field === 'actions'" class="actions-cell">
            <button @click="deleteRow(props.row.originalIndex)" class="delete-btn">
              <span class="delete-icon">×</span>
            </button>
          </div>
        </template>
      </vue-good-table>

      <div class="add-product" @click="addNewRow">
        <button class="add-btn">+</button>
        <span class="add-text">Add a new product</span>
      </div>

      <div class="total-value">
        TOTAL VALUE: ${{ calculateGrandTotal }}
      </div>
    </div>


    <div v-click-outside="hideSuggestions" id="sell-to-us-search" :class="{'search-suggestions': showSuggestions, 'sell-to-us-search': showSuggestions}">
      <div  v-if="showSuggestions" class="search-suggestions-inner custom-scrollbar" ref="searchSuggestionsInner">
        <div class="product-suggestion">
          <h6 class="title">{{ $trans("storefront::layout.product_suggestions") }}</h6>
          <ul class="list-inline product-suggestion-list">
            <li
              v-for="(product, index) in products"
              :key="product.slug"
              class="list-item"
              :ref="product.slug"
            >
              <div class="single-item cursor-pointer" @click="onProductClick(index)">
                <div class="d-flex">
                  <!-- image -->
                  <div class="pr-1">
                    <img
                      :src="baseImage(product)"
                      :class="{ 'image-placeholder': !hasBaseImage(product) }"
                      class="rounded custom-product-image"
                      alt="product image"
                      @error="handleImageError"
                    />
                  </div>

                  <!-- details -->
                  <div class="d-flex w-100 pl-1">
                    <div class="d-flex flex-column w-100">
                      <h6 class="product-name text-dark text-wrap" v-html="product.name"></h6>

                      <div class="search-price">
                        <span class="formatted-price" v-html="productPrice(product)"></span>
                        <!--                        <span class="text-primary mx-1">|</span>-->
                        <span style="color: #343a40" v-if="product.qty_in_stock && !product.is_pre_order">
                          Each <span style="color: #DEAA5E">({{ product.search_qty }} Available)</span>
                        </span>
                      </div>

                      <div class="d-flex flex-column flex-md-row justify-content-between align-items-baseline">
                        <div class="d-flex">
                          <div v-if="product.is_daily_deal_today" class="daily-deal-badge">
                            <small>Daily Deal ${{ currencyFormat(product.daily_deal_price) }} USD</small>
                          </div>
                          <div v-if="product.is_hot" class="hot-product-badge">
                            <img :src="hotImage" alt="" />
                            <small>Hot Product</small>
                          </div>
                          <div
                            v-if="product.is_rare_find" class="rare-find-product-badge width-fit-content">
                            <small>RareFind</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
            </li>
          </ul>

        </div>
      </div>
    </div>

    <SellForm :rows="rows" :countries="countries" :states="states"></SellForm>
  </div>
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';
import { currencyFormat } from "@core/helpers/configHelper"
import DateMixin from "@core/mixin/DateMixin"
import ApiMixin from "@core/mixin/ApiMixin"
import clickOutside from "@core/directives/clickOutside"
import { infinityScroll } from "@core/directives/infinityScroll"
import SellForm from "./Form.vue"
export default {
  mixins: [DateMixin, ApiMixin],
  directives: { infinityScroll, clickOutside },
  props: {
    countries: { required: true },
    states: { required: true },
    conditions: { required: true }
  },
  components: {
    VueGoodTable, SellForm
  },
  watch: {
    searchTerm(newValue) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.page = 1
        this.searchResults = []
        if (newValue.length > 0) {
          this.showSuggestions = true
          this.fetchResults(newValue)
        } else {
          this.searchResults = []
        }
      }, 1000)
    }
  },
  data() {
    return {
      defaultImage: `themes/storefront/public/images/image-placeholder.png`,
      showSuggestions: false,
      products: [],
      searchTerm: "",
      searchResults: [],
      debounceTimer: null,
      page: 1,
      totalPages: 1,
      apiLoading: false,
      columns: [
        { label: "Item Description", field: "description", width: "300px" },
        { label: "Country", field: "country_id" },
        { label: "Type", field: "type" , width: "150px"},
        { label: "Condition", field: "condition_id" },
        { label: "Pick", field: "pick" },
        { label: "Denomination", field: "denomination" },
        { label: "Year", field: "year" },
        { label: "Customer Price", field: "customer_price" },
        { label: "Customer Quantity", field: "customer_quantity" },
        { label: "Total", field: "customer_total_offer" },
        { label: "", field: "actions", width: "50px" },
      ],
      rows: [this.getEmptyRow()],
      types: ["Banknote", "Coin", "Set"],
      conditions: ["UNC", "Used", "Damaged"],
      currentIndex: 0,
      selectedProducts: []
    };
  },
  computed: {
    calculateGrandTotal() {
      return this.rows.reduce((total, row) => {
        return total + Number(row.customer_price) * Number(row.customer_quantity);
      }, 0).toFixed(2);
    },
    shouldShowSuggestions() {
      if (!this.showSuggestions) {
        return false
      }

      return this.hasAnySuggestion
    },
    hasAnySuggestion() {
      return this.suggestions.products.length !== 0
    },
  },
  methods: {
    currencyFormat,
    hasBaseImage(product) {
      return product.base_image !== null && product.base_image !== ""
    },
    baseImage(product) {
      if (this.hasBaseImage(product)) {
        return product.base_image
      }
      return `${window.Trillion.baseUrl}/themes/storefront/public/images/image-placeholder.png`
    },
    apiUrl(value) {
      return "/suggestions?query=" + value + "&per_page=10" + "&page=" + this.page
    },
    fetchResults(value) {
      this.showSuggestions = true
      if (this.apiLoading) return

      this.apiLoading = true
      $.ajax({
        method: "GET",
        url: route("suggestions.index", { query: value })
      }).then(suggestions => {
        if (suggestions !== undefined) {
          this.products = suggestions.products
        }
        this.apiLoading = false
      })
    },
    closeSearch() {
      this.searchTerm = ""
      this.searchResults = []
    },
    getEmptyRow() {
      return {
        description: "",
        country: "USA",
        type: "",
        condition: "",
        pick_number: "",
        denomination: "",
        year: "",
        customer_price: 0,
        customer_quantity: 0,
        media: [],
        mediaIds: []
      };
    },
    updateRow(index, field, value) {
      this.currentIndex = index
      this.$set(this.rows, index, {
        ...this.rows[index],
        [field]: value,
      });
      if (field == 'description') {
        let el = document.getElementById('product-name-' + index)
        let rec = el.getBoundingClientRect()
        let top = rec.top + window.scrollY
        clearTimeout(this.debounceTimer)
        top = top + 50
        document.getElementById('sell-to-us-search').style.setProperty("top", top + "px");

        if (value.length > 0) {
          this.fetchResults(value)
        } else {
          this.searchResults = []
        }
      }
    },
    calculateTotal(row) {
      let total = (Number(row.customer_price) * Number(row.customer_quantity)).toFixed(
        2
      )
      row.customer_total_offer = total
      return total
    },
    addNewRow() {
      this.rows.push(this.getEmptyRow());
    },
    deleteRow(index) {
      this.rows.splice(index, 1);
      this.selectedProducts.splice(index, 1)
      if (this.rows.length === 0) {
        this.addNewRow();
      }
    },
    onProductClick(index) {
      this.rows[this.currentIndex].selected = true;
      this.selectedProducts[this.currentIndex] = this.products[index]
      this.rows[this.currentIndex].description = this.products[index].name
      this.rows[this.currentIndex].type = this.products[index].type
      this.rows[this.currentIndex].country_id = this.products[index].country_id
      this.rows[this.currentIndex].year = this.products[index].year
      this.rows[this.currentIndex].denomination = this.products[index].denomination
      this.rows[this.currentIndex].pick = this.products[index].pick_number
      this.rows[this.currentIndex].product_id = this.products[index].id
      this.rows[this.currentIndex].files = [this.products[index].media[0].id]
      this.rows[this.currentIndex].mediaIds = [this.products[index].media[0].id]
    },
    productPrice(product) {
      return '$' + currencyFormat(product.selling_price.formatted)
    },
    hideSuggestions() {
      this.showSuggestions = false
    },
    handleImageError(event) {
      // Handle the image loading error by replacing the image source with the default image source
      event.target.src = this.defaultImage;
    },
    setMedia(ids, rowIndex) {
      this.updateRow(rowIndex, 'mediaIds', ids)
      this.updateRow(rowIndex, 'files', ids)
    },
  },
};
</script>

<style scoped>
.sell-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.hero-banner {
  background: linear-gradient(to right, #1a1a1a, #22a7bf);
  color: white;
  padding: 40px;
  margin-bottom: 30px;
  border-radius: 8px;
}

.hero-banner h1 {
  font-size: 2.5em;
  margin: 0;
}

.highlight {
  color: #22a7bf;
}

.table-section {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.vgt-table {
  border: 1px solid #ddd;
  border-radius: 4px;
}

.vgt-table th {
  background-color: var(--color-default) !important;
  color: white !important;
  padding: 12px !important;
  font-weight: 500;
}

.table-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.table-select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.price-cell {
  position: relative;
}

.currency {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
}

.price-input {
  padding-left: 20px;
}

.delete-btn {
  background: none;
  border: none;
  color: #ff4444;
  cursor: pointer;
  padding: 4px 8px;
  font-size: 20px;
}

.add-product {
  display: flex;
  align-items: center;
  margin-top: 20px;
  cursor: pointer;
}

.add-btn {
  background-color: var(--color-default);
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  cursor: pointer;
  font-size: 20px;
}

.add-text {
  color: var(--color-default);
  font-weight: 500;
}

.total-value {
  text-align: right;
  margin-top: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 4px;
  font-weight: bold;
  font-size: 1.2em;
}


.btn-pre-order {
  background: #dc3545 !important;
}

.custom-product-image {
  height: 80px;
  width: 75px;
  object-fit: contain;
}

.rare-find-product-badge,
.hot-product-badge,
.daily-deal-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  padding: 4px 14px;
  margin-right: 10px;
  gap: 5px;

  small {
    color: #ffffff;
    font-size: 12px;
  }
}

.hot-product-badge {
  background: #ff5656;
  color: #fff;
}

.rare-find-product-badge {
  background: green;
}

.daily-deal-badge {
  background: #40c887;
  color: #fff;
}

.out-of-stock-badge {
  background: #ffc656;
  color: #fff;
}

.in-stock-badge {
  background: var(--primary);
  color: #fff;
}

.out-of-stock-badge,
.in-stock-badge {
  height: 25px;
  min-width: fit-content;
  border-radius: 4px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  margin-right: 10px;
}

.sell-to-us-search {
  width: 400px !important;
  left: 65px;
}

.table-section th  {
  background: $color-default !important;
  color: #fff !important;
}

.h-38 {
  height: 38px;
}
</style>
